module.exports = __webpack_public_path__ + "static/bo-ca05d6f06df58df554e3287bc8300405.svg";